import * as THREE from 'three';
import React, { Suspense } from 'react';
import { OrbitControls, PerspectiveCamera, View } from '@react-three/drei';

import Lights from './Lights';
import Iphone from './Iphone';
import Loader from './Loader';

interface ModalViewProps {
    index: number;
    groupRef: React.MutableRefObject<THREE.Group<THREE.Object3DEventMap>>;
    gsapType: 'view1' | 'view2';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    controlRef: any;
    setRotationState: (rot: number) => void;
    item: {
        title: string;
        color: string[];
        img: string;
    };
    size: string;
}

const ModalView = ({
    index,
    groupRef,
    gsapType,
    controlRef,
    setRotationState,
    item,
    size,
}: ModalViewProps) => {
    return (
        <View
            index={index}
            id={gsapType}
            className={`size-full absolute ${index === 2 ? 'right-[-100%]' : ''}`}>
            {/* Ambient light */}
            <ambientLight intensity={0.3} />
            <PerspectiveCamera makeDefault position={[0, 0, 4]} />
            <Lights />
            <OrbitControls
                makeDefault
                ref={controlRef}
                enableZoom={false}
                enablePan={false}
                rotateSpeed={0.4}
                target={new THREE.Vector3(0, 0, 0)}
                onEnd={() =>
                    setRotationState(controlRef?.current?.getAzimuthalAngel())
                }
            />
            <group
                ref={groupRef}
                name={`${index === 1} ? 'small': 'large'`}
                position={[0, 0, 0]}>
                <Suspense fallback={<Loader />}>
                    <Iphone
                        scale={index === 1 ? [15, 15, 15] : [17, 17, 17]}
                        item={item}
                        size={size}
                    />
                </Suspense>
            </group>
        </View>
    );
};

export default ModalView;
